
import React, { useContext, useEffect } from "react";
import { useLocation } from "react-router-dom";
import AdminTopBar from "../../components/admin/AdminTopBar/AdminTopBar";
import AdminSideBar from "../../components/admin/AdminSideBar/AdminSidebar";
import AppContext from "../../context/AppContext";
import "../../assets/css/admin/AdminMasterLayout/AdminMasterLayout.css";

const AdminMasterLayout = ({ children }) => {
  const location = useLocation();
  const { selectedScreenOfAdminDashboardSidebar, setLoggedInAdmin } = useContext(AppContext);

  const sidebarItems = [
    { path: "/admin-dashboard", label: "Dashboard" },
    { path: "/admin-categories", label: "Category Management" },
    { path: "/admin-shops", label: "Shop Management" },
    { path: "/admin-topup-requests", label: "Top-Up Requests" },
    { path: "/admin-payout-requests", label: "Payout Requests" },
    { path: "/admin-blogs", label: "Blogs" },
    { path: "/admin-faqs", label: "FAQs" },
    { path: "/admin-marquee", label: "Marquee" },
    { path: "/admin-supports", label: "Support Tickets" },
    { path: "/admin-notifications", label: "Notifications" },
    { path: "/admin-setting", label: "Settings" },
  ];

  const currentPage = sidebarItems.find(
    (item) => item.path === location.pathname
  );

  const breadcrumbs = [
    { label: "Admin Panel", href: "/admin-dashboard" },
    ...(currentPage
      ? [{ label: currentPage.label, href: currentPage.path }]
      : []),
  ];

  useEffect(() => {
    const savedAdmin = JSON.parse(localStorage.getItem("loggedInAdmin"));
    setLoggedInAdmin(savedAdmin);
  }, []);

  return (
    // CHANGE 1: Container/Row/Col aur wrapper-div dono hata diye —
    // sidebar khud "position: fixed" hai, is liye usay wrap/width dene ki zarurat nahi
    <div className="admin-layout-wrapper">
      <AdminSideBar />

      {/* CHANGE 2: content area ko "admin-content" class di — margin-left CSS file mein handle hoga */}
      <div className="admin-content">
        <div className="pt-2">
          <AdminTopBar
            title={selectedScreenOfAdminDashboardSidebar}
            breadcrumbs={breadcrumbs}
          />
        </div>

        <div className="mt-3">
          {children}
        </div>
      </div>
    </div>
  );
};

export default AdminMasterLayout;
